import { useContext, useEffect } from "react";
import { SupportContext } from "./SupportProvider";

// Retain the viewed profile for the global support menu without a second button.
export default function SkorTicketButton({ tenant, isGuarantor = false }) {
  const setProfile = useContext(SupportContext);
  useEffect(() => {
    if (!setProfile) return undefined;
    const profile = { tenant, isGuarantor };
    setProfile(profile);
    return () =>
      setProfile((current) => (current === profile ? null : current));
  }, [setProfile, tenant, isGuarantor]);
  return null;
}
